/* The Clari Edit · small, accessible, editor-safe motion controller. */
(() => {
  'use strict';
  const settingsEl = document.getElementById('clari-motion-config');
  if (!settingsEl) return;
  let settings;
  try { settings = JSON.parse(settingsEl.textContent); } catch (_) { return; }
  const body = document.body;
  if (!body) return;
  body.dataset.clariHover = String(settings.hover);
  body.dataset.clariReveal = String(settings.reveal);
  body.dataset.clariStickers = String(settings.stickers);
  body.dataset.clariMobile = String(settings.mobile);
  const speed = ({soft: 760, medium: 570, playful: 400})[settings.speed] || 760;
  body.style.setProperty('--clari-motion-time', `${speed}ms`);
  body.style.setProperty('--clari-hover-distance', `${settings.hoverDistance || 6}px`);
  body.style.setProperty('--clari-reveal-distance', `${settings.revealDistance || 18}px`);
  const motionSafe = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer;
  if (settings.reveal && motionSafe && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('clari-reveal-visible');
        observer.unobserve(entry.target);
      }
    }, {rootMargin:'0px 0px -30px 0px', threshold:0.08});
  }
  function setup(scope=document) {
    if (!observer) return;
    if (!settings.mobile && window.matchMedia('(max-width:749px)').matches) return;
    const selectors = [
      '.ce h1', '.ce h2', '.ce .ce-tag', '.ce .ce-kicker', '.ce .ce-card',
      '.ce .ce2-problems > div', '.ce .ce2-toolgrid > article',
      '.ce .cp-money-grid > div', '.ce .ce2-reviewgrid > blockquote',
      '.ce .ce2-mini-benefits > div', '.ce .ce-art',
      '.ce .clari-cart-points > div', '.ce .ce-news > div',
      ".ce .clari-movable-decor[data-clari-entrance='true']"
    ];
    const nodes = [...scope.querySelectorAll(selectors.join(','))];
    // Guard performance on large pages; each element is observed only once.
    for (const el of nodes) {
      if (el.classList.contains('clari-reveal-pending')) continue;
      if (el.getBoundingClientRect().bottom <= 0) continue;
      el.classList.add('clari-reveal-pending');
      observer.observe(el);
    }
  }
  setup();
  // In Shopify's editor, replace and reinitialize freshly loaded sections.
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const el=event.target;
    if (!el) return;
    if (el.classList.contains('clari-reveal-pending')) {
      el.classList.add('clari-reveal-visible');
      observer?.unobserve(el);
    }
  });
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener?.('change', (event) => {
    if (!event.matches) return;
    document.querySelectorAll('.clari-reveal-pending').forEach(el => {
      el.classList.add('clari-reveal-visible');
      observer?.unobserve(el);
    });
  });
})();
